export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A1818] text-[#FAF9F6]/80 py-14 px-6"
    >
      <div className="max-w-5xl mx-auto text-center">
        <p className="font-display text-3xl md:text-4xl text-[#FAF9F6] mb-3">
          Michelle <span className="italic text-[#A3C1DA]">&amp;</span> Niall
        </p>
        <p className="text-[10px] tracking-luxe uppercase mb-6 text-[#FAF9F6]/60">
          4 June 2027 · Glenlo Abbey, Galway
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-[#FAF9F6]/60">
          <span>Le grá ó Michelle &amp; Niall</span>
          <span aria-hidden>·</span>
          <a
            href="/rsvp"
            className="hover:text-[#A3C1DA] transition-colors"
            data-testid="footer-rsvp-link"
          >
            RSVP
          </a>
          <span aria-hidden>·</span>
          <a
            href="#schedule"
            className="hover:text-[#A3C1DA] transition-colors"
            data-testid="footer-schedule-link"
          >
            Schedule
          </a>
        </div>
      </div>
    </footer>
  );
}
